import React from 'react';
import { motion } from 'framer-motion';

const RefundPage: React.FC = () => {
  return (
    <div>
      <motion.h1 
        className="text-4xl font-baloo text-yellow-500 mb-8"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Refund Policy
      </motion.h1>
      
      <motion.div 
        className="card max-w-2xl mx-auto"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="text-center mb-6">
          <motion.span 
            className="text-5xl"
            animate={{ 
              rotate: [0, 10, -10, 10, 0],
              scale: [1, 1.1, 1, 1.1, 1]
            }}
            transition={{ repeat: Infinity, duration: 4 }}
          >
            💰
          </motion.span>
        </div>
        
        <p className="text-xl font-comic text-center mb-6">
          We only give refunds if you have a hair in your drink, 
          but most likely that won't happen!
        </p>
        
        <div className="bg-yellow-50 p-4 rounded-lg">
          <h3 className="text-xl font-baloo font-bold mb-2">Allergy Information</h3>
          <p className="font-comic">
            We are not responsible if you are allergic to lemonade. 
            We have never heard of a lemonade allergy, so that's good!
          </p>
          <p className="font-comic mt-4">
            Banana bread & cupcakes contain gluten, nuts, and eggs. 
            You could die if allergic and eat it, so don't do that!
          </p>
          <p className="font-comic mt-4 font-bold">
            Please be CAREFUL!!
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default RefundPage; 